import { Component } from '@angular/core';
import { AbstractFieldComponent } from '../abstract-field.component';

@Component( {
    selector: 'erp-pbw-telefon',
    templateUrl: './input-field.component.html'
} )
export class PhoneNumberComponent extends AbstractFieldComponent<string> {

    constructor() {
        super( 'rm.erp.jobapplication.JobApplication.phoneNumber' );
    }

    set value( t: string | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.phoneNumber = t;
        }
    }

    get value(): string | undefined {
        return this.jobapplication?.phoneNumber;
    }
}
